import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";

const LitigantBox = ({
    mt = '',
    mb = '',
}) => {
    const { theme } = useCustomLogic();

    return (
        <Box sx={{
            display: 'inline-block',
            mt: mt || '10px',
            mb: mb || '10px',
            backgroundColor: '#DC002D',
            padding: '10px 52px 10px 52px',
            color: theme.palette.common.white
        }}>
            <Typography>LITIGANT SURVEY</Typography>
        </Box>
    )
}

export default LitigantBox;